import React, { useState } from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewCMSPageNew from "../../components/CMS/ViewCMSPageNew";

const ViewCMSPage = () => {
  const [cmsTitle, setCmsTitle] = useState("View CMS"); // default until fetched

  return (
    <>
      <MasterLayout>
      {/* <Breadcrumb id="title" title2="CMS" link2="/cms" title="View CMS" />
        {/* <Breadcrumb id="title" title2="CMS" link2="/cms" title={cmsTitle} /> */}
      {/* <ViewCMSPageNew onTitleLoad={(title) => setCmsTitle(title)} /> */}

       {/* Pass static breadcrumb path, but dynamic heading */}
      <Breadcrumb
        title={"View CMS"} // Dynamic heading
        title2="CMS"                   // Static breadcrumb parent
        link2="/cms"
        cmsTitle={cmsTitle}
      />

      {/* CMS view content */}
      <ViewCMSPageNew onTitleLoad={(title) => setCmsTitle(title)} />
      </MasterLayout>

    </>
  );
};

export default ViewCMSPage;
